export enum UserRoles {
  student = "Student",
  school = "School",
  company = "Company",
  municipality = "Municipality",
  admin = "Admin",
}

export const AnyRole = Object.values(UserRoles);
